import { render, staticRenderFns } from "./SystemUpdateCard.vue?vue&type=template&id=44b30d62&scoped=true&"
import script from "./SystemUpdateCard.vue?vue&type=script&lang=js&"
export * from "./SystemUpdateCard.vue?vue&type=script&lang=js&"
import style0 from "./SystemUpdateCard.vue?vue&type=style&index=0&id=44b30d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b30d62",
  null
  
)

export default component.exports